import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const LoginPage = () => {
  const navigate = useNavigate()
  const auth = useAuth()

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/dashboard')
    }
  }, [auth.isAuthenticated, navigate])

  const handleSignIn = () => {
    void auth.signinRedirect()
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl">ToDoNE</CardTitle>
          <CardDescription>Sign in to start documenting your builds</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button className="w-full" onClick={handleSignIn} disabled={auth.isLoading}>
            {auth.isLoading ? 'Loading...' : 'Sign in with Keycloak'}
          </Button>
          {auth.error && <p className="text-xs text-destructive">{auth.error.message}</p>}
          <p className="text-center text-xs text-muted-foreground">
            Dev users: <strong>demo / demo</strong>, <strong>alice / alice</strong>,{' '}
            <strong>bob / bob</strong>. Google sign-in is also available on the Keycloak page for
            accounts on the testing-mode allowlist.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
